import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";

export interface CandidateClaimsSearchCompleteDialogData {
  title: string;
  message: string;
  okAction: string;
}

@Component({
  selector: "app-candidate-claims-search-complete-dialog",
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: "./candidate-claims-search-complete-dialog.component.html",
  styleUrls: ["./candidate-claims-search-complete-dialog.component.scss"],
})
export class CandidateClaimsSearchCompleteDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<CandidateClaimsSearchCompleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    readonly data: CandidateClaimsSearchCompleteDialogData,
  ) {}

  onOk(): void {
    this.dialogRef.close(true);
  }
}
